import React from 'react';
import FraudCaseDetailSection from '../../../sections/AdminDashboard/SecurityFraud/FraudCaseDetail';

const FraudCaseDetail = () => {
  return <FraudCaseDetailSection />;
};

export default FraudCaseDetail;

